export default "__VITE_ASSET__629840e7__"